import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/product/page";
import CrownChatPage from "../pages/crowchat/page";
import ResellerDashboard from "../pages/reseller/page";
import BuyerRfqPage from "../pages/buyer-rfq/page";
import FactoryQuotesPage from "../pages/factory-quotes/page";
import FactoryDashboardPage from "../pages/factory-dashboard/page";
import BuyerConfirmPage from "../pages/buyer-confirm/page";
import InfluencerDashboard from "../pages/influencer/page";
import BooksPage from "../pages/books/page";
import DonationPage from "../pages/donation/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/product/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/crowntalk",
    element: <CrownChatPage />,
  },
  {
    path: "/crowchat",
    element: <CrownChatPage />,
  },
  {
    path: "/reseller-dashboard",
    element: <ResellerDashboard />,
  },
  {
    path: "/buyer-rfq",
    element: <BuyerRfqPage />,
  },
  {
    path: "/factory-quotes",
    element: <FactoryQuotesPage />,
  },
  {
    path: "/factory-dashboard",
    element: <FactoryDashboardPage />,
  },
  {
    path: "/buyer-confirm",
    element: <BuyerConfirmPage />,
  },
  {
    path: "/influencer-dashboard",
    element: <InfluencerDashboard />,
  },
  {
    path: "/books",
    element: <BooksPage />,
  },
  {
    path: "/donation",
    element: <DonationPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
